<script>
import FirebaseNodeV3 from '../../base/FirebaseNode'
import CSurvey from "../../../editor/nodes/CSurvey.vue";

export default CSurvey.extend({
  name: "CSurveyV3",
  mixins: [FirebaseNodeV3],
})
</script>
